import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { Image, P, Stack } from '@fashionnovateam/nova-ui-toolkit';
import { useGetVendorItem } from '../../../../Lib/Hooks/ItemService';
import CountryList from '../../../../Lib/Constants/countries';
import { useGetItemPhotoURLs } from '../../../../Lib/Hooks/ItemService/useGetItemPhotoURLs';

export function ItemKeyDetailsReadOnly() {
  const { id: currentUserId, itemId: currentItemId } = useParams<{
    id: string;
    itemId: string;
  }>();

  const { data: targetItem } = useGetVendorItem(currentUserId, currentItemId);
  const { data: photoUrls } = useGetItemPhotoURLs(currentUserId, currentItemId);

  const countryToDisplay = useMemo(
    () =>
      CountryList.find(
        (country) =>
          country.value === targetItem?.draft_purchase_order?.country_of_origin,
      )?.text ?? '-',
    [targetItem?.draft_purchase_order?.country_of_origin],
  );

  const swatchImageThumbnailUrl = photoUrls?.swatch_photo?.thumbnail_url;
  const swatchImageUrl = photoUrls?.swatch_photo?.url;

  if (!targetItem) {
    return null;
  }

  return (
    <Stack direction="row" className="gap-6">
      <Stack direction="col" gap="sm">
        <P size="xsm" color="primary" weight="medium">
          Key Details
        </P>
        <Stack direction="row" gap="sm">
          <Stack direction="col" gap="none">
            <span className="text-sm text-[#1D24338C]">JR Unit Cost</span>
            <P size="sm" color="primary">
              ${targetItem.jr_cost}
            </P>
          </Stack>
          <Stack direction="col" gap="none">
            <span className="text-sm text-[#1D24338C]">Plus Unit Cost</span>
            <P size="sm" color="primary">
              {targetItem.plus_cost !== null ? `$${targetItem.plus_cost}` : '-'}
            </P>
          </Stack>
        </Stack>
        <div className="h-px bg-[#1D24331A]" />
        <Stack direction="row" gap="sm">
          <Stack direction="col" gap="none">
            <span className="text-sm text-[#1D24338C]">Lead Time</span>
            <P size="sm" color="primary">
              {targetItem.lead_time_in_weeks} weeks
            </P>
          </Stack>
          <Stack direction="col" gap="none">
            <span className="text-sm text-[#1D24338C]">COO</span>
            <P size="sm" color="primary">
              {countryToDisplay}
            </P>
          </Stack>
        </Stack>
        <div className="h-px bg-[#1D24331A]" />
        <Stack direction="row" gap="sm">
          <Stack direction="col" gap="none">
            <span className="text-sm text-[#1D24338C]">FN Exclusive</span>
            <P size="sm" color="primary">
              {targetItem.fashionnova_exclusive ? 'Yes' : 'No'}
            </P>
          </Stack>
          <Stack direction="col" gap="none">
            <span className="text-sm text-[#1D24338C]">Fit Sample</span>
            <P size="sm" color="primary">
              {targetItem.fit_sample ? 'Yes' : 'No'}
            </P>
          </Stack>
        </Stack>
      </Stack>
      <Stack direction="col" gap="md">
        <P size="xsm" color="primary" weight="medium">
          Swatches
        </P>
        <Image
          key={
            swatchImageThumbnailUrl ||
            swatchImageUrl ||
            'swatch-image-placeholder'
          }
          src={swatchImageThumbnailUrl}
          fallbackSrc={swatchImageUrl}
          alt="Swatch"
          className="w-24 h-24 object-cover rounded-lg border"
        />
      </Stack>
    </Stack>
  );
}
